/**
 * useRouteAnalytics Hook
 * Tracks route performance and navigation analytics
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ============================================================================
// Route Analytics Hook
// ============================================================================

// Future analytics integration types:
// interface RouteAnalyticsData {
//   pathname: string;
//   timestamp: number;
//   loadTime?: number;
//   referrer?: string;
//   userAgent?: string;
// }
//
// interface RoutePerformanceMetrics {
//   navigationStart: number;
//   loadStart: number;
//   loadEnd?: number;
//   duration?: number;
// }

export const useRouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const navigationStart = performance.now();

    // Track performance metrics when route is fully loaded
    const handleRouteLoaded = () => {
      const loadEnd = performance.now();
      const duration = loadEnd - navigationStart;

      // In production, you might want to send this to an analytics service
      // Example:
      // analyticsData.loadTime = duration;
      // analytics.track('route_performance', analyticsData);

      // Prevent unused variable warning
      void duration;
    };

    // Use requestAnimationFrame to wait for the next paint
    const timeoutId = window.setTimeout(handleRouteLoaded, 0);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.pathname]);

  return {
    currentPath: location.pathname,
    currentSearch: location.search,
    currentHash: location.hash,
  };
};

export default useRouteAnalytics;
